import { render, staticRenderFns } from "./editProgram.vue?vue&type=template&id=570d608c"
import script from "./editProgram.vue?vue&type=script&lang=js"
export * from "./editProgram.vue?vue&type=script&lang=js"
import style0 from "./editProgram.vue?vue&type=style&index=0&id=570d608c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports